module.exports = __webpack_public_path__ + "static/ICONS_DistanceDiagnos-e89f9924edd40e61e463de30bab873d5.png";